// extracted by mini-css-extract-plugin
export default {"RecipePage":"RecipePage_RecipePage__lN+-1","recipes":"RecipePage_recipes__5ZGg4"};